/**
 * forEach iterates through the provided object entries, calling the iteratee function
 * for each key-value pair. Similar to Array.prototype.forEach but for objects.
 *
 * @param object the object to iterate over
 * @param iteratee Function called for each entry with parameters (value, key, object)
 */
export const forEach = <T extends Record<string, unknown>>(
  object?: T | null,
  iteratee?: (value: T[keyof T], key?: keyof T, object?: T | null) => void
) => {
  const objectEntries = Object.entries(object ?? {}) as [string, T[keyof T]][];

  if (objectEntries.length > 0 && typeof iteratee === "function") {
    for (const [key, value] of objectEntries) {
      iteratee(value, key, object);
    }
  }
};
